<div class="listado-temas">
  <div class="header">
    <div class="titulos">
      <h2>Temas festivos</h2>
      <span class="subtitulo">
        Decorados y efecto de partículas que se muestran en IRIX según la fecha
      </span>
    </div>
  </div>

  <app-tabla
    [totalCount]="temas.length"
    [datos]="loading && !temas.length ? undefined : temas"
    [columnas]="columnas"
    [name]="name"
    [(query)]="query"
    [paginatorAbajo]="false"
    [crear]="botonCrear"
    [fillParent]="false"
    [emptyState]="{ title: 'Todavía no hay temas' }"
  ></app-tabla>
</div>
